import React, { useCallback, useState } from 'react';
import { SimpleModal } from '../../ui/NormalModal';
import { useSelector } from 'react-redux';
import store from '../../../redux/store';
import { updateOpenModals } from '../../../redux/Slice/gridSlice';
import { handleMeshUpload } from '../../gridpagefunction/Mesh';
import { handleImageUpload } from '../../gridpagefunction/image';
import { iconsPath } from '../../../utils/imagePath';
import { handleVideoUpload } from '../../gridpagefunction/Video';
import { handleAudioUpload } from '../../gridpagefunction/Audio';
import { handleMeshPlyUpload } from '../../gridpagefunction/MeshPly';
import { handleMeshObjUpload } from '../../gridpagefunction/MeshObj';
import { handleMeshFbxUpload } from '../../gridpagefunction/MeshFbx';
import toast from 'react-hot-toast';

const UploadSection = ({ objectt }) => {
  const { openModals } = useSelector((state) => state.assets_object);
  const [isDragging, setIsDragging] = useState(false);

  const AppTopectionData = [
    {
      title: '3D Asset',
      type: 'GLB',
      icon: iconsPath?.vector8Image,
      accept: '.glb,.gltf',
      onclick: handleMeshUpload,
      id: 'addMesh',
      obj: objectt,
    },
    {
      title: 'Image',
      type: 'JPG, PNG',
      icon: iconsPath?.group74Image,
      accept: 'image/jpeg, image/png',
      onclick: handleImageUpload,
      id: 'addImage',
      obj: objectt,
    },
    {
      title: 'Video',
      type: 'MP4',
      icon: iconsPath?.vector9Image,
      accept: 'video/mp4',
      onclick: handleVideoUpload,
      id: 'addVideo',
      obj: objectt,
    },
    {
      title: 'Sound',
      type: 'MP3, WAV',
      icon: iconsPath?.group72Image,
      accept: 'audio/mpeg, audio/wav',
      onclick: handleAudioUpload,
      id: 'addVAudio',
      obj: objectt,
    },
    {
      title: 'Gaussian Splat',
      type: 'PLY',
      icon: iconsPath?.gaussianSplat,
      accept: '.ply',
      onclick: handleMeshPlyUpload,
      id: 'addMeshPly',
      obj: objectt,
    },
    {
      title: 'OBJ Mesh',
      type: 'OBJ (Folder)',
      icon: iconsPath?.vector8Image,
      accept: '.obj',
      onclick: handleMeshObjUpload,
      id: 'addMeshObj',
      obj: objectt,
    },
    {
      title: 'FBX Mesh',
      type: 'FBX (Folder)',
      icon: iconsPath?.vector8Image,
      accept: '.fbx',
      onclick: handleMeshFbxUpload,
      id: 'addMeshFbx',
      obj: objectt,
    },
    
    {
      title: 'Vector',
      type: 'SVG',
      icon: iconsPath?.group73Image,
      accept: 'image/svg+xml',
      badges: 'Coming Soon',
    },
    {
      title: 'Sprite',
      type: 'GIF',
      icon: iconsPath?.vector10Image,
      accept: 'image/gif',
      badges: 'Coming Soon',
    },
  ];

  // 👉 Handle file drop onto the modal
  const handleFileDrop = useCallback(
    (e) => {
      e.preventDefault();
      setIsDragging(false);

      const file = e.dataTransfer.files[0];
      if (!file) return;

      const lower = file.name.toLowerCase();
      const fakeEvent = { target: { files: [file] } };

      // 🔹 Check and handle supported types
      if (
        lower.endsWith('.glb') ||
        lower.endsWith('.gltf')
        //  ||
        // lower.endsWith('.obj')
      ) {
        handleMeshUpload(fakeEvent, objectt);
      } else if (/\.(jpg|jpeg|png)$/i.test(lower)) {
        handleImageUpload(fakeEvent, objectt);
      } else if (lower.endsWith('.mp4')) {
        handleVideoUpload(fakeEvent, objectt);
      } else if (lower.endsWith('.mp3')) {
        handleAudioUpload(fakeEvent, objectt);
      } else if (lower.endsWith('.ply')) {
        handleMeshPlyUpload(fakeEvent, objectt);
      } else if (lower.endsWith('.fbx')) {
        const fbxFiles = Array.from(e.dataTransfer.files || []);
        handleMeshFbxUpload({ target: { files: fbxFiles.length ? fbxFiles : [file] } }, objectt);
      } else if (lower.endsWith('.obj')) {
        handleMeshObjUpload(fakeEvent, objectt);
      }
      // 🔹 Unsupported type
      else {
        toast.error(
          <div>
            <strong>Unsupported File Type</strong>
            {/* <div>{file.name} cannot be uploaded.</div> */}
            <div>Supported: GLB, PLY, JPG, PNG, MP4, MP3,</div>
          </div>,
          {
            style: {
              background: '#121316',
              color: '#fff',
              padding: '12px',
              borderRadius: '8px',
            },
            icon: '⚠️',
            position: 'top-center',
          }
        );
        return; // stop further processing
      }

      // Close the modal after successful drop
      store.dispatch(updateOpenModals({ name: 'upload', isOpen: false }));
    },
    [objectt]
  );

  return (
    <SimpleModal
      isOpen={openModals.upload}
      onClose={() =>
        store.dispatch(updateOpenModals({ name: 'upload', isOpen: false }))
      }
      bg={'bg-none'}
      className="w-fit flex justify-center items-center"
    >
      <div
        onDragOver={(e) => {
          e.preventDefault();
          setIsDragging(true);
        }}
        onDragLeave={(e) => {
          e.preventDefault();
          setIsDragging(false);
        }}
        onDrop={handleFileDrop}
        className={`bg-[#131418] p-6 rounded-lg shadow-lg mx-2 fixed top-[190px] left-[36%] sm:left-1/2 sm:-translate-x-1/2 max-w-[90vw] sm:max-w-md 
        ${isDragging ? 'border border-dashed border-[#ee2b2a]' : ''}
`}
      >
        <h3 className="text-white text-[14px] font-semibold text-center mb-4">
          Upload or Drag & Drop
        </h3>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 border border-dashed border-[#8A8A8A] rounded-[10px] px-2 py-2">
          {AppTopectionData.map((section) => (
            <label
              key={section.title}
              onClick={(e) => e.stopPropagation()}
              className="relative flex flex-col gap-1 items-center justify-center h-[100px] w-full sm:w-[110px] bg-[#31333A] hover:bg-[#54565E] text-white rounded-[10px] cursor-pointer transition"
            >
              {section.badges && (
                <p className="absolute -top-1 -right-1 text-[9px] bg-[#54565C] px-2 py-[3px] rounded-[5px]">
                  {section.badges}
                </p>
              )}

              <img className="w-4 h-4" src={section.icon} alt={section.title} />
              <div className="text-[14px] font-normal opacity-80 text-[#D9D9D9]">
                {section.title}
              </div>
              <small className="text-[10px] text-[#D9D9D9]">
                {section.type}
              </small>

              {/* Enable folder upload for OBJ Mesh and FBX Mesh */}
              {section.title === 'OBJ Mesh' || section.title === 'FBX Mesh' ? (
                <input
                  type="file"
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    e.stopPropagation();
                    section.onclick && section.onclick(e, section.obj);
                    store.dispatch(
                      updateOpenModals({ name: 'upload', isOpen: false })
                    );
                  }}
                  id={section.id}
                  className="hidden"
                  accept={section.accept}
                  webkitdirectory=""
                  directory=""
                  multiple
                />
              ) : (
                <input
                  type="file"
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    e.stopPropagation();
                    section.onclick && section.onclick(e, section.obj);
                    store.dispatch(
                      updateOpenModals({ name: 'upload', isOpen: false })
                    );
                  }}
                  id={section.id}
                  className="hidden"
                  accept={section.accept}
                />
              )}
            </label>
          ))}
        </div>
      </div>
    </SimpleModal>
  );
};

export default UploadSection;
